module.exports = __webpack_public_path__ + "static/media/deals.c0704543.png";